import { HugeiconsIcon } from "@hugeicons/react";
import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
} from "@hugeicons-pro/core-stroke-rounded";
import { Button } from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import useTranslations from "../../i18n/useTranslations";

const NAV = "size-5.5 rounded-full hover:bg-foreground/10 [&_svg]:size-3.5";

const TierNav: FC = () => {
  const { send } = useRewardCenter();
  const t = useTranslations();

  return (
    <span
      data-slot="tier-nav"
      className="flex items-center gap-0.5 rounded-full border-t border-t-foreground/10 bg-foreground/10 px-1.5 py-0.5 backdrop-blur-md"
    >
      <Button
        variant="unstyled"
        size="icon-xs"
        aria-label={t("reward_center.tier.previous")}
        className={NAV}
        onClick={() =>
          send("rewardCenter", { type: "browseTier", direction: "prev" })
        }
      >
        <HugeiconsIcon icon={ArrowLeft01Icon} />
      </Button>
      <Button
        variant="unstyled"
        size="icon-xs"
        aria-label={t("reward_center.tier.next")}
        className={NAV}
        onClick={() =>
          send("rewardCenter", { type: "browseTier", direction: "next" })
        }
      >
        <HugeiconsIcon icon={ArrowRight01Icon} />
      </Button>
    </span>
  );
};

export default TierNav;
